import { A11yModule } from "@angular/cdk/a11y";
import { DialogModule } from "@angular/cdk/dialog";
import { CommonModule } from "@angular/common";
import { NgModule, Type } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";

import { CallToActionComponent } from "@hermes/aphrodite/call-to-action";
import {
    CarouselComponent,
    CarouselPartDirective,
} from "@hermes/aphrodite/carousel";
import { CheckboxComponent } from "@hermes/aphrodite/fields";
import { MessageBlockComponent } from "@hermes/aphrodite/message-block";
import { CurrencyModule, PriceComponent } from "@hermes/aphrodite/price";
import {
    svgCircleBan,
    SvgIconComponent,
    SvgRegistryService,
} from "@hermes/aphrodite/svg";
import { CallToActionAddToCartModule } from "@hermes/fragments/call-to-action-add-to-cart";
import { ModalModule } from "@hermes/fragments/modal";
import { ExternalLibraryStateModule } from "@hermes/states/external-library";
import { VtoBeautyStateModule } from "@hermes/states/vto-beauty";
import { ImageErrorDefaultDirective } from "@hermes/utils-generic/directives/image-error-default";
import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic/directives/sr-only-no-snippet";
import { ImageUrlPipeModule } from "@hermes/utils-generic/pipes/image-url";

import { VirtualTryOnAddToCartComponent } from "./components/virtual-try-on-add-to-cart/virtual-try-on-add-to-cart.component";
import { VirtualTryOnCameraComponent } from "./components/virtual-try-on-camera/virtual-try-on-camera.component";
import { VirtualTryOnModalComponent } from "./components/virtual-try-on-modal/virtual-try-on-modal.component";
import { VirtualTryOnSelectorComponent } from "./components/virtual-try-on-selector/virtual-try-on-selector.component";
import { VirtualTryOnVariantItemComponent } from "./components/virtual-try-on-variant-item/virtual-try-on-variant-item.component";
import { VirtualTryOnVariantsComponent } from "./components/virtual-try-on-variants/virtual-try-on-variants.component";
import { VtoScrollSelectAnimationDirective } from "./directives/vto-scroll-animation.directive";
import { VtoScrollDirective } from "./directives/vto-scroll-to.directive";

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        CheckboxComponent,
        CallToActionComponent,
        A11yModule,
        VtoBeautyStateModule,
        TranslateModule,
        PriceComponent,
        RouterModule,
        MessageBlockComponent,
        CallToActionAddToCartModule,
        SvgIconComponent,
        ExternalLibraryStateModule,
        CurrencyModule,
        DialogModule,
        ModalModule,
        CarouselComponent,
        CarouselPartDirective,
        SrOnlyNoSnippetDirective,
        ImageUrlPipeModule,
        ImageErrorDefaultDirective,
    ],
    declarations: [
        VtoScrollDirective,
        VtoScrollSelectAnimationDirective,
        VirtualTryOnModalComponent,
        VirtualTryOnCameraComponent,
        VirtualTryOnSelectorComponent,
        VirtualTryOnVariantsComponent,
        VirtualTryOnVariantItemComponent,
        VirtualTryOnAddToCartComponent,
    ],
    exports: [VirtualTryOnModalComponent],
})
export class VtoBeautyModalModule {
    constructor(svgRegistryService: SvgRegistryService) {
        svgRegistryService.registerSvgs([svgCircleBan]);
    }

    public resolveComponent(): Type<VirtualTryOnModalComponent> {
        return VirtualTryOnModalComponent;
    }
}
